import { Screen } from "../components/Screen";
import { Footer } from "../components/Footer";
import { CSSProperties, useEffect, useState } from "react";
import { Font } from "../constants/fonts";
import { Colors } from "../constants/colors";
import { Icons } from "../constants/icons";

export default function NossosDiferenciais() {
    const [isMobile, setIsMobile] = useState(false);
    
    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    if (isMobile) {
        return (
            <Screen>
                <div style={mobileStyles.containerTop}>
                    <div style={mobileStyles.card}>
                        <div style={mobileStyles.title}>
                            Mais que mobilidade — um novo conceito de conexão.
                        </div>
                    </div>
                    
                    <img src="/Rectangle%2056.svg" alt="ClickMob diferenciais" style={mobileStyles.logo}/>
                    
                    <div style={mobileStyles.card}>
                        <div style={mobileStyles.text}>
                            O ClikMob vai além de transportar pessoas. Ele cria oportunidades, incentiva a economia local e valoriza o trabalho de quem faz a cidade se mover.
                        </div>
                    </div>
                </div>
                
                <div style={mobileStyles.containerBottom}>
                    <img src="/Group 16.svg" alt="ClickMob benefícios" style={mobileStyles.logo2}/>
                    
                    <div style={mobileStyles.featuresGrid}>
                        <div style={mobileStyles.featureItem}>
                            <Icons
                                color={Colors.white}
                                name="money"
                                size={28}
                            />
                            <div style={mobileStyles.featureText}>
                                <b>Ganho real aos motoristas:</b> tarifas justas e parcerias vantajosas.
                            </div>
                        </div>
                        
                        <div style={mobileStyles.featureItem}>
                            <Icons
                                color={Colors.white}
                                name="tool"
                                size={28}
                            />
                            <div style={mobileStyles.featureText}>
                                <b>Descontos em manutenção:</b> benefícios reais para quem dirige.
                            </div>
                        </div>
                        
                        <div style={mobileStyles.featureItem}>
                            <Icons
                                color={Colors.white}
                                name="warning"
                                size={28}
                            />
                            <div style={mobileStyles.featureText}>
                                <b>Botão SOS integrado:</b> segurança reforçada em situações de risco.
                            </div>
                        </div>
                        
                        <div style={mobileStyles.featureItem}>
                            <Icons
                                color={Colors.white}
                                name="message"
                                size={28}
                            />
                            <div style={mobileStyles.featureText}>
                                <b>Atendimento direto:</b> motorista e passageiro em contato transparente.
                            </div>
                        </div>
                        
                        <div style={mobileStyles.featureItem}>
                            <Icons
                                color={Colors.white}
                                name="target"
                                size={28}
                            />
                            <div style={mobileStyles.featureText}>
                                <b>Vantagens para passageiros:</b> descontos reais em parceiros locais.
                            </div>
                        </div>
                        
                        <div style={mobileStyles.featureItem}>
                            <Icons
                                color={Colors.white}
                                name="wheel-chair"
                                size={28}
                            />
                            <div style={mobileStyles.featureText}>
                                <b>Sustentabilidade e inclusão:</b> viagens adaptadas para PCDs, idosos, mulheres, autistas e donos de pets.
                            </div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </Screen>
        );
    }

    // Return original (desktop) intacto
    return (
        <Screen>
            <div style={styles.conteinerTop}>
                <div>
                    <div style={styles.card}>
                        <div style={styles.title}>
                            Mais que mobilidade — um novo conceito de conexão.
                        </div>
                    </div>
                    <br></br>
                    <div style={styles.card}>
                        <div style={styles.text}>
                            O ClikMob vai além de transportar pessoas. Ele cria oportunidades, incentiva a economia local  e valoriza o trabalho de quem faz a cidade se mover.
                        </div>
                    </div>
                </div>
                <div>
                    <img src="/Rectangle%2056.svg" alt="ClickMob logo" style={styles.logo}/>
                </div>
            </div>
            <div style={styles.conteinerBottom}>
                <div>
                    <div style={styles.line}>
                        <Icons
                            color={Colors.white}
                            name="money"
                            size={35}
                        />
                        <div style={styles.text}>
                            <b>Ganho real aos motoristas:</b> tarifas justas e parcerias vantajosas.
                        </div>
                    </div>
                    <div style={styles.line}>
                        <Icons
                            color={Colors.white}
                            name="tool"
                            size={35}
                        />
                        <div style={styles.text}>
                            <b>Descontos em manutenção:</b> benefícios reais para quem dirige.
                        </div>
                    </div>
                    <div style={styles.line}>
                        <Icons
                            color={Colors.white}
                            name="warning"
                            size={35}
                        />
                        <div style={styles.text}>
                            <b>Botão SOS integrado:</b> segurança reforçada em situações de risco.
                        </div>
                    </div>
                    <div style={styles.line}>
                        <Icons
                            color={Colors.white}
                            name="message"
                            size={35}
                        />
                        <div style={styles.text}>
                            <b>Atendimento direto:</b> motorista e passageiro em contato transparente.
                        </div>
                    </div>
                    <div style={styles.line}>
                        <Icons
                            color={Colors.white}
                            name="target"
                            size={35}
                        />
                        <div style={styles.text}>
                            <b>Atendimento direto:</b> descontos reais em parceiros locais.
                        </div>
                    </div>
                    <div style={styles.line}>
                        <Icons
                            color={Colors.white}
                            name="wheel-chair"
                            size={35}
                        />
                        <div style={styles.text}>
                            <b>Sustentabilidade e inclusão:</b> viagens adaptadas para PCDs, idosos, mulheres, autistas e  donos de pets.
                        </div>
                    </div>
                </div>
                <div>
                    <img src="/Group 16.svg" alt="ClickMob logo" style={styles.logo2}/>
                </div>
            </div>
            <Footer/>
        </Screen>
    );
}

// Estilos desktop originais (mantidos intactos)
const styles:  { [key: string]: CSSProperties } = {
    conteinerTop: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        gap: 30,
        padding: 55
    },
    title: {
        fontSize: Font.title2.fontSize,
        color: Colors.white,
        textAlign: 'justify',
        fontWeight: Font.title2.fontWeight
    },
    text: {
        fontSize: Font.menu.fontSize,
        textAlign: 'justify',
        color: Colors.white
    },
    card: {
        padding: '25px',
        borderRadius: '20px',
        backgroundColor: Colors.primary
    },
    logo: {
        height: 335,
        borderRadius: 30
    },
    conteinerBottom: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        padding: 60,
        backgroundColor: Colors.primary
    },
    text2: {
        fontSize: Font.text.fontSize,
        textAlign: 'justify',
        color: Colors.white
    },
    line: {
        width: '90%',
        display: 'flex',
        alignItems: 'center',
        gap: 15,
        margin: '60px 0'
    },
    logo2: {
        height: 675,
        borderRadius: 20
    }
}

// Estilos mobile otimizados
const mobileStyles: { [key: string]: CSSProperties } = {
    containerTop: {
        display: 'flex',
        flexDirection: 'column',
        gap: 25,
        padding: '30px 20px',
        backgroundColor: Colors.gray,
    },
    title: {
        fontSize: Font.title2.fontSize * 0.85,
        color: Colors.white,
        textAlign: 'center',
        fontWeight: Font.title2.fontWeight,
        lineHeight: 1.3,
    },
    text: {
        fontSize: Font.menu.fontSize * 0.95,
        textAlign: 'center',
        color: Colors.white,
        lineHeight: 1.5,
    },
    card: {
        padding: '20px',
        borderRadius: '15px',
        backgroundColor: Colors.primary,
        width: '100%',
    },
    logo: {
        width: '100%',
        maxWidth: 300,
        height: 'auto',
        borderRadius: '15px',
        margin: '0 auto',
        display: 'block',
    },
    containerBottom: {
        display: 'flex',
        flexDirection: 'column',
        padding: '40px 20px',
        backgroundColor: Colors.primary,
        gap: 40,
    },
    logo2: {
        width: '100%',
        maxWidth: 280,
        height: 'auto',
        borderRadius: 15,
        margin: '0 auto',
        display: 'block',
    },
    featuresGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 25,
        marginTop: 20,
    },
    featureItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 12,
        textAlign: 'center',
    },
    featureText: {
        fontSize: Font.menu.fontSize * 0.85,
        color: Colors.white,
        lineHeight: 1.3,
    },
};